export default __webpack_public_path__ + "static/media/webbing3.6ee9e605.png";